import type { NavGroup, NavItem } from './types'

export type NavSessionPermissions = {
  isArtemAdmin: boolean
  isArtemEarthEmail: boolean
  canAccessPackagingSuppliers: boolean
  canWriteOrgData: boolean
}

function itemAllowedByPermission(
  permission: NavItem['permission'],
  permissions: NavSessionPermissions
): boolean {
  if (permission === 'isArtemAdmin') {
    return permissions.isArtemAdmin
  }
  if (permission === 'isArtemEarthEmail') {
    return permissions.isArtemEarthEmail
  }
  if (permission === 'canAccessPackagingSuppliers') {
    return permissions.canAccessPackagingSuppliers
  }
  if (permission === 'canWriteOrgData') {
    return permissions.canWriteOrgData
  }
  return true
}

function filterNavItem(
  item: NavItem,
  permissions: NavSessionPermissions
): NavItem | null {
  if (!itemAllowedByPermission(item.permission, permissions)) {
    return null
  }

  if (!item.items) {
    return item
  }

  const nestedItems = item.items.filter((nestedItem) =>
    itemAllowedByPermission(nestedItem.permission, permissions)
  )
  if (nestedItems.length === 0) {
    return null
  }

  return {
    ...item,
    items: nestedItems,
  }
}

export function filterNavGroupsBySession(
  navGroups: NavGroup[],
  permissions: NavSessionPermissions
): NavGroup[] {
  return navGroups
    .map((group) => ({
      ...group,
      items: group.items
        .map((item) => filterNavItem(item, permissions))
        .filter((item): item is NavItem => item != null),
    }))
    .filter((group) => group.items.length > 0)
}
